export default {
    methods: {
        initials(contact, short) {
            let output = '';

            if (!contact) {
                return false;
            }

            let first_name = contact.first_name || contact.firstName || contact.user_first_name;
            let last_name = contact.last_name || contact.lastName || contact.user_last_name;

            if (first_name) {
                output = first_name.substr(0, 1);

                if (last_name) {
                    output += last_name.substr(0, 1);
                }
            } else if (contact.email) {
                output = contact.email.substr(0, 1);
            } else if (contact.national_number) {
                output = contact.national_number.substr(0, 1);
            }

            if (short) {
                output = output.substr(0, 1);
            }

            return output ? output.toUpperCase() : false;
        },
    },
};
